import { apiFetchJson } from '@wundo/client/api.ts';

/** A track as a form offers it: enough to pick one and name it. */
export interface TrackOption {
  id: string;
  title: string;
}

/** What the tracks endpoint answers with. Only what a picker needs is read. */
interface TrackListResponse {
  data: {
    id: string;
    title: string;
  }[];
}

/**
 * The organisation's tracks, for the admins who target something at one.
 *
 * Same request as `fetchCohorts`, for the same reasons: one page feeds a
 * dropdown, and a superadmin has to say whose tracks they want.
 */
export async function fetchTracks(organisationId: string): Promise<TrackOption[]> {
  const params = new URLSearchParams({ limit: '100', organisation_id: organisationId });
  const { data } = await apiFetchJson<TrackListResponse>(`/tracks?${params}`);

  return data.map((track) => ({ id: track.id, title: track.title }));
}
